import apiInterface from "./apiInterface";
import { post, get } from "./axiosConfig";
import VueCookie from "vue-cookie";
import enumInfo from "./enum";
import moment from "moment"; //时间控件
import qs from "qs";
moment.locale("en");
const cookieUser = 'MiaoU'
const cookieDaka = 'MiaoCategory'
// 给单数时间加零 , 1=>01
export function NuberZero(val) {
  if (Number(val) < 10) {
    return "0" + val;
  } else {
    return val;
  }
}
// 判断数字是否存在千分位
export function isNumber(val) {
  //console.log(val, Number(val).toString(), "Number(val).toString()");
  return Number(val).toString() != "NaN" ?
    Number(val) :
    Number(val.replace(/,/gi, ""));
}
//是否登录
export function getInfo() {
  let info = VueCookie.get(cookieUser);
  // console.log('info', info)
  if (info != null && info.length > 0) {
    return JSON.parse(info);
  } else {
    return null;
  }
}

//设置用户信息
export function setInfo(key, val) {
  let info = VueCookie.get(cookieUser);
  info = JSON.parse(info);
  info[key] = val;
  let time = new Date(new Date().getTime() + 96 * 60 * 60 * 1000);
  VueCookie.set(cookieUser, JSON.stringify(info), {
    expires: time
  });
}

export function login(val) {
  let info = val
  let time = new Date(new Date().getTime() + 96 * 60 * 60 * 1000);
  VueCookie.set(cookieUser, JSON.stringify(info), {
    expires: time
  });
}


//获取地址列表
export function addressList() {
  let info = VueCookie.get(cookieUser);
  let data = { MemberId: JSON.parse(info).Id, PageIndex: 1, PageSize: 10 };
  return get(apiInterface.Interface.SearchShippingAddresses, data);
}
//获取类目列表
export function getCategory() {
  return get(apiInterface.Interface.GetOnlyCategories, "");
}

//把类目列表放入缓存,由于cookies大小不够，所以放在本地缓存里面，用cookies
// type => get,set
// key => 本地缓存的key
// val => 存入本地缓存的key
// fun => 作用就是return
export function CookiesCategory(type, key, val, fun) {
  if (type == "get") {
    let isCategory = VueCookie.get(cookieDaka);
    if (isCategory != 0 && isCategory != null&&isCategory.length>0) {
      try {
        let valList = window.localStorage.getItem(val);
        valList = JSON.parse(valList);
        //console.log(valList,'valList')
        if (valList == null) {
          type = "set";
        } else {
          new fun(valList);
        }
      } catch (err) {
        type = "set";
      }
    } else {
      type = "set";
    }
  }
  if (type == "set") {
    
    let time = new Date(new Date().getTime() + 5 * 60 * 60 * 1000);
    VueCookie.set(cookieDaka, 1, { expires: time });
    if (val == "miaoshop") {
      getCategory().then(res => {
        console.log(res,'res')
        if (res.Result != 0) {
          let result = resetCategory(res.Data);
          //let result = res.Data;
          window.localStorage.setItem(val, JSON.stringify(result));
          new fun(result);
        }
      });
    }
  }
}

//三级分类显示  分类结构重组
// Category => 传入类目的值
// type => card:官方商城
function resetCategory(Category, type) {
  console.log(Category)
  var ctg = [];
  Category.map(function(o, k) {
    //重组一级分类
    var f = o["FirstCategory"]["Category"];
    var label = {
      id: f["_id"],
      label: f["ChName"],
      // EnName: f["EnName"],
      children: []
    };
    // if (type == "card") {
    //   console.log('label.id',f["ID"])
    //   label.id = f["ID"];
    // }
    ctg.push(label);
    //重组二级分类
    o["FirstCategory"]["SecondCategories"].map(function(oo, kk) {
      var ooData = {
        id: oo["Category"]["_id"],
        label: oo["Category"]["ChName"],
        EnName: oo["Category"]["EnName"],
        Fid: f["_id"],
        children: []
      };
      // if (type == "card") {
      //   ooData.id = oo["Category"]["ID"];
      //   ooData.Fid = f["ID"];
      // }

      ctg[k]["children"].push(ooData);
      if (oo["Properties"]!= null) {
        //重组三级分类
        oo["Properties"].map(function(ooo, kkk) {
          var oooData = {
            id: ooo["_id"],
            label: ooo["ChName"],
            ChName: ooo["ChName"],
            EnName: ooo["ControlName"],
            FCName: f["ChName"],
            // FEName: f["EnName"],
            Fid: f["_id"],
            SCName: oo["Category"]["ChName"],
            // SEName: oo["Category"]["EnName"],
            Sid: oo["Category"]["_id"],
            // Properties: ooo["CategoryProperties"],
          };
          // if (type == "card") {
          //   oooData.id = ooo["Category"]["ID"];
          //   oooData.Fid = f["ID"];
          //   oooData.Sid = oo["Category"]["ID"];
          // }

          ctg[k]["children"][kk]["children"].push(oooData);
        });
      }
    });
  });
  return ctg;
}
// 加法
export function numAdd(num1, num2) {
  var baseNum, baseNum1, baseNum2;
  try {
    baseNum1 = num1.toString().split(".")[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split(".")[1].length;
  } catch (e) {
    baseNum2 = 0;
  }
  baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
  return (numMulti(num1, baseNum) + numMulti(num2, baseNum)) / baseNum;
}
// 减法
export function numSub(num1, num2) {
  var baseNum, baseNum1, baseNum2;
  var precision;
  try {
    baseNum1 = num1.toString().split(".")[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split(".")[1].length;
  } catch (e) {
    baseNum2 = 0;
  }
  baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
  precision = baseNum1 >= baseNum2 ? baseNum1 : baseNum2;
  return (
    (numMulti(num1, baseNum) - numMulti(num2, baseNum)) /
    baseNum
  ).toFixed(precision>=2?2:precision);
}
// 乘法
export function numMulti(num1, num2) {
  var baseNum = 0;
  try {
    baseNum += num1.toString().split(".")[1].length;
  } catch (e) {}
  try {
    baseNum += num2.toString().split(".")[1].length;
  } catch (e) {}
  return (
    (Number(num1.toString().replace(".", "")) *
      Number(num2.toString().replace(".", ""))) /
    Math.pow(10, baseNum)
  );
}
// 除法
export function numDiv(num1, num2) {
  var baseNum1=0,baseNum2=0;
  var baseNum3,baseNum4;
  try{
    baseNum1=num1.toString().split(".")[1].length;
  }catch(e){
    baseNum1=0;
  }
  try{
    baseNum2=num2.toString().split(".")[1].length;
  }catch(e){
    baseNum2=0;
  }
    baseNum3=Number(num1.toString().replace(".",""));
    baseNum4=Number(num2.toString().replace(".",""));
   return (baseNum3/baseNum4)*(Math.pow(10,baseNum2-baseNum1));
  // with(Match){
  //   baseNum3=Number(num1.toString.replace(",",""));
  //   baseNum4=Number(num2.toString.replace(",",""));
  //   return (baseNum3/baseNum4)*Math.pow(10,baseNum2-baseNum1);
  // }
}
// 获取屏幕宽度
export function GetWindowsWidth() {
  let w_width = document.documentElement.clientWidth;
  return w_width;
}
// 向上取整
export function numCeil(val) {
  //console.log(val, 'val')
  let num = val;
  return Math.ceil(val);
}
// logout
export function toLogout(val) {
  VueCookie.delete(cookieUser, {});
  window.location.href = "/";
}
// 去除emoji表情，type 0:回车换行,type 1:回车换行空格
export function isEmoji(val, type) {
  let value = val;
  value = value.replace(
    /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi,
    ""
  );
  value = value.replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g, "");
  value = value.replace(/[\uE000-\uF8FF]/g, "");
  if (type === 0) {
    //禁止回车换行
    value = value.replace(/<\/?.+?>/g, "");
    value = value.replace(/[\r\n]/g, "");
  }
  if (type === 1) {
    value = value.replace(/\s+/g, "");
    value = value.replace(/<\/?.+?>/g, "");
    value = value.replace(/[\r\n]/g, "");
  }
  return value;
}

export function countries(obj){
  const sortedCountries = obj.sort((a, b) => {
    const nameA = a.EnName.toUpperCase();
    const nameB = b.EnName.toUpperCase();
    
    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;
    return 0;
  });
  return sortedCountries
}



// WEBPACK FOOTER //
// ./src/api/public.js